import React, {useState } from "react";
import { SpacingCustom } from "../../../layout/Spacing/SpacingCustom";
import { TDisplay } from "../../../../interface/interfaces";
import { DashboardListWarning } from "./DashboardListWarning";
import { DashboardLayout } from "../DashboardLayout";
import { DashboardLayoutGridAndRows } from "../DashboardLayoutGridAndRows";
import { DashboardFilter } from "./DashboardFilter";
import { useDashboardFilterHide } from "./hooks/useDashboardFilterHide";
import { DashboardFilterWindow } from "../DashboardFilter/DashboardFilterWindow";

interface IDashbosrdListMainProps {
    articleList: JSX.Element[],
    display?: TDisplay
}      

export const DashboardListMain:React.FC<IDashbosrdListMainProps> = ({articleList, display = 'row'})=>{

    const {showControls, hasAnimated, scrollRef} = useDashboardFilterHide(300);
    const [openFilter, setOpenFilter] = useState(false);

    

    return (
        <DashboardLayout isRelative scrollRef={scrollRef}>
            <SpacingCustom paddingBottom={2} paddingTop={1}>
   
            </SpacingCustom>
            <DashboardFilterWindow openFilter = {openFilter} func={()=>setOpenFilter(false)}/>
                <DashboardFilter func={()=>setOpenFilter(true)} display={display} position='relative'/>
                <DashboardFilter func={()=>setOpenFilter(true)} showElem = {hasAnimated} display={display} position='absolute' hasAnimated={showControls}/>
            {
                articleList !== undefined && articleList.length > 0
                ?
                <>

                    <SpacingCustom paddingTop={1}>
                        <DashboardLayoutGridAndRows display={display}>
                            {articleList}
                        </DashboardLayoutGridAndRows>
                    </SpacingCustom>
                </>
                :
                <DashboardListWarning/>
            }
        </DashboardLayout>
    )
}
